import * as React from 'react';
import { Layout } from '../components/layout';
import { Role } from '../models/role';
import { AdminGuard } from '../guard/admin-guard';
import { GerarCertificadosLotePage } from '../pages/gerar-certificados-lote/gerar-certificados-lote';
import TemplatesCertificadosPage from '../pages/templates-certificados/templates-certificados';
import { CertificadosClientePage } from '../pages/certificados-cliente/CertificadosClientePage';

const headerProps = {
  name: 'Certificados',
};

export const AdminRoutes = [
  {
    routePath: '/certificados-cliente',
    isExactPath: true,
    ifHaveTheseRoles: [Role.Administrador, Role.GestorNacional, Role.GestorUF],
    pageToRender: (
      <Layout headerProps={headerProps}>
        <CertificadosClientePage />
      </Layout>
    ),
    orRedirectTo: '/',
  },
  {
    routePath: '/gerar-certificados-lote',
    isExactPath: true,
    ifHaveTheseRoles: [Role.Administrador, Role.GestorNacional, Role.GestorUF],
    pageToRender: (
      <Layout headerProps={headerProps}>
        <GerarCertificadosLotePage />
      </Layout>
    ),
    orRedirectTo: '/',
  },
  {
    routePath: '/templates-certificados',
    isExactPath: true,
    pageToRender: (
      <AdminGuard>
        <Layout headerProps={headerProps}>
          <TemplatesCertificadosPage />
        </Layout>
      </AdminGuard>
    ),
  },
];
